import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-calendar/dist/Calendar.css";
import App from "./App.jsx";

// Service Worker 등록
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('✅ Service Worker 등록 성공:', registration.scope);
      })
      .catch(error => {
        console.error('❌ Service Worker 등록 실패:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode> // 배포 시에 주석 해제 - alert 두 번 발생
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function

// to log results (for example: reportWebVitals(console.log))

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// reportWebVitals();
